module.exports = __webpack_public_path__ + "images/emoji/japanese_castle.412716909c20cbe44535.png";